// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8b8c1284","239":"69a8cf37","455":"3cf15877"}[chunkId] + ".chunk.js";
};